class Menu {
  constructor() {
    this.header = document.querySelector(".site-header");
    this.scrollOffset = 38;
    this.init();
  }

  init() {
    window.addEventListener("scroll", () => this.handleScroll());
  }

  handleScroll() {
    if (window.scrollY > this.scrollOffset) {
      this.header.classList.add("header-scrolled");
    } else {
      this.header.classList.remove("header-scrolled");
    }
  }
}

export default Menu;
